export const enum SSO_PROVIDERS {
  ENTRAID = 'entraid',
}

export const SSO_DOMAIN_PROVIDER_MAP: Record<string, SSO_PROVIDERS> = {
  'ceva.com': SSO_PROVIDERS.ENTRAID,
  'filavie.com': SSO_PROVIDERS.ENTRAID,
  'laprovet.com': SSO_PROVIDERS.ENTRAID,
};
